module.exports = __webpack_public_path__ + "img/saudi-arabia.60d4e15e.svg";